module.exports = __webpack_public_path__ + "media/images/emblems/Cressier_NE-coat_of_arms-0d1b8edb28e97153c1dc8eae31c27217.svg";